import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";

export const BaseDialog = ({
  openState = false,
  setOpenState = () => { },
  title = "",
  titleSx,
  content,
  contentSx,
  actions,
  actionSx,
  disableScape = false,
  transition = undefined,
  fullWidth = false,
  maxWidth = undefined,
  hideBackdrop = false,
  closeIcon = false,
  PaperProps = {},
}) => {

  const handleClose = () => {
    setOpenState(false);
  }

  return (
    <Dialog
      open={openState}
      onClose={handleClose}
      disableEscapeKeyDown={disableScape}
      TransitionComponent={transition}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      hideBackdrop={true}
      PaperProps={{
        sx: {
          zIndex: 999999,
          ...PaperProps?.sx,
        },
        ...PaperProps,
      }}
      sx={{
        zIndex: 999999,
      }}
    >
      <Box sx={{ padding: "5px" }}>
        {closeIcon && (
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: "2px",
              right: "5px",
              zIndex: 1,
            }}
          >
            <Close />
          </IconButton>
        )}
        <DialogTitle sx={titleSx}>{title}</DialogTitle>
        <DialogContent sx={contentSx}>{content}</DialogContent>
        <DialogActions sx={actionSx}>
          {actions &&
            actions.map((action, index) => {
              return (
                <Button
                  key={index}
                  onClick={action.onClick}
                  sx={action.style}
                  startIcon={action.icon}
                  autoFocus={action.autoFocus}
                >
                  {action.label}
                </Button>
              );
            })}
        </DialogActions>
      </Box>
    </Dialog>
  );
}
